import { Injectable } from '@angular/core';

@Injectable()
export class SessionService {
 //isLogin:string;
  constructor() {
 
  }

  setSessionLogin(){
    localStorage.setItem('isLogin',"true");
    
    return true;
  }
  setSessionPermission(permission:string){
    localStorage.setItem('permission',permission);
    console.log('session',permission);
    return true;
  }
  setSessionName(name:string){
    localStorage.setItem('name',name);
    console.log('session',name);
    return true;
  }
  setSessionUserId(userid:string){
    localStorage.setItem('userid',userid);
    console.log('session',userid);
    return true;
  }

  getSessionLogin(){
    return localStorage.getItem('isLogin');
  }
  getSessionPermission(){
    return localStorage.getItem('permission');
  }
  getSessionName(){
    return localStorage.getItem('name');
  }
  getSessionUserId(){
    return localStorage.getItem('userid');
  }

  sessionDestroy(sessionName:string){
    localStorage.removeItem(sessionName);
  }
 

}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/session.service.ts